import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LifeBuoy, X } from 'lucide-react';
import { api, auth } from '../lib/api';

const keyFor = (email) => `apexflow.recovery-email-banner.dismissed.${email}`;

export default function RecoveryEmailBanner() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const user = auth.currentUser();

  useEffect(() => {
    if (!user || user.role !== 'admin' || pathname === '/settings') { setShow(false); return; }
    try { if (localStorage.getItem(keyFor(user.email))) { setShow(false); return; } } catch { /* ignore */ }
    let alive = true;
    api.get('/auth/recovery-email')
      .then(({ data }) => { if (alive) setShow(!data.recovery_email); })
      .catch(() => { if (alive) setShow(false); });
    return () => { alive = false; };
  }, [user?.email, user?.role, pathname]);

  useEffect(() => {
    document.documentElement.style.setProperty('--apex-banner-offset', show ? '40px' : '0px');
    return () => document.documentElement.style.setProperty('--apex-banner-offset', '0px');
  }, [show]);

  if (!show) return null;

  const dismiss = () => {
    try { localStorage.setItem(keyFor(user.email), String(Date.now())); } catch { /* ignore */ }
    setShow(false);
  };

  return (
    <div data-testid="recovery-email-banner"
         className="flex items-center gap-3 px-4 py-2"
         style={{ background: 'rgba(245, 166, 35, 0.08)', borderBottom: '1px solid var(--accent-amber)',
                  color: 'var(--accent-amber)', fontSize: 12, fontFamily: 'monospace' }}>
      <LifeBuoy size={14} />
      <span className="flex-1">
        <b>NO VERIFIED RECOVERY EMAIL.</b> Password-reset links for this admin account have nowhere safe to go.
        Set one in Settings — requires a fresh TOTP step-up and a code from the new mailbox.
      </span>
      <button className="btn-sharp" onClick={() => { dismiss(); navigate('/settings'); }} data-testid="recovery-email-banner-setup"
              style={{ padding: '4px 10px', fontSize: 10, fontWeight: 700, color: 'var(--accent-amber)', border: '1px solid var(--accent-amber)' }}>
        SET RECOVERY EMAIL
      </button>
      <button onClick={dismiss} aria-label="dismiss" data-testid="recovery-email-banner-dismiss"
              style={{ color: 'var(--accent-amber)', background: 'transparent', border: 0, cursor: 'pointer' }}>
        <X size={14} />
      </button>
    </div>
  );
}
